/**
 * Finance command-lookup API facade.
 * Wraps the generated lookupFinanceCommandOptions SDK function.
 *
 * QG-CLI-COMP-004: this stayed in core (unlike the other finance-*.api.ts
 * modules) because its only consumer, `components/conversations/
 * ConversationCommandPanel.tsx`, is core conversation-composer slash-command
 * infrastructure rendered unconditionally (not gated behind the finance
 * module) — moving this file would have made that core component statically
 * import from `modules/finance/client`, which is the exact violation the rest
 * of COMP-004 fixes. Re-gating the whole slash-command subsystem behind
 * module enablement is a larger, separate change outside this finding's scope.
 */
import { lookupFinanceCommandOptions } from '../../generated/api/sdk.gen.js';
import { unwrapGenerated } from './generated.js';
import type { FinanceCommandLookupOption, LookupFinanceCommandOptionsData } from '../../generated/api/types.gen.js';

type CommandName = NonNullable<LookupFinanceCommandOptionsData['query']['command']>;

export type { FinanceCommandLookupOption, CommandName };

export const financeCommandsApi = {
  async lookup(
    command: CommandName,
    q?: string,
    limit?: number,
  ): Promise<{ command: CommandName; options: FinanceCommandLookupOption[]; truncated: boolean }> {
    const response = await unwrapGenerated(
      lookupFinanceCommandOptions({
        query: {
          command,
          ...(q ? { q } : {}),
          ...(limit != null ? { limit: String(limit) } : {}),
        },
      }),
    );
    return response.data;
  },
};
